<template>
    <el-dialog
        title="修改密码"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :beforeClose="cancel"
        width="500px"
        center>
        <div class="flex flex-direction">
            <el-form :model="setForm" :rules="rules" ref="setForm" label-width="110px" label-position="left">
                <el-form-item label="新密码：" prop="newPass">
                    <el-input v-model="setForm.newPass" placeholder="请输入新密码" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="newRPass">
                    <el-input v-model="setForm.newRPass" placeholder="请再次输入新密码" type="password"></el-input>
                </el-form-item>
                <div class="flex flex-direction align-center justify-center">
                    <el-button class="padding-lr-xl" type="primary" @click="submitForm('setForm')">确认修改</el-button>
                    <div class="tips margin-top">提示：密码过于简单，请先修改密码</div>
                </div>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>



import {setJdPass} from "@/api/login";

export default {
    name: "ChangePasswordDialog",
    data() {
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.setForm.newPass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            setForm: {
                oldPass: '',
                newPass: '',
                newRPass: '',
            },
            rules: {
                newPass: [{required: true, message: '请输入新密码', trigger: 'change'},
                    {
                        pattern: '^(?=.*\\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$',
                        message: '密码需要包含数字及字母且8-20个字符',
                        trigger: 'change'
                    }],
                newRPass: [{required: true, validator: validatePass2, trigger: 'blur'}],
            }
        }
    },
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        token: {
            type: String,
            default: ''
        }
    },
    computed: {},
    methods: {
        //  修改密码提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData() {
            let _state = await setJdPass(
                this.token,
                this.setForm.newPass,
                this.setForm.newRPass,
            );
            if (_state.status === 200) {
                this.$emit('cancelDialog', true);
            } else {
                this.$message.error(_state.info);
            }
        },
        cancel() {
            this.$emit('cancelDialog', false)
        }
    },
    watch: {}
}
</script>

<style scoped lang="scss">
.tips {
    color: red;
}
</style>
